module.exports = __webpack_public_path__ + "static/img/3.dbb694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R22/3.jpg
// module id = mUhq
// module chunks = 1